
const MatSelectButtons = ({step}) =>{

    let option = document.querySelector(`.step-${step} input[type="radio"]:checked`);

    // console.log('option',option);

    if (option === null){
        return null;
    }else{
        return(
            <div className="mat-navs">
                <span className="to-top" onClick={() => document.querySelector('#body-core').scrollTo(0,0)}></span>
                <span className="to-select" onClick={() => document.querySelector('.calc input[type="radio"]:checked+label').scrollIntoView(true)}></span>
                <span className="to-next" onClick={() => document.querySelector('.btn.btn-next').click()}></span>
                <span className="to-info" onClick={() => document.querySelector('.prod-descr').scrollIntoView(true)}></span>
            </div>
        )
    }

}
export default MatSelectButtons;